<script>

export default {
  name: 'tourist-menu'
}
</script>

<template>
  <b-dropdown
    :hoverable="true"
    aria-role="list"
    class="app-header__dropdown"
    position="is-bottom-left"
  >
    <button
      slot="trigger"
      class="app-header__dropdown-button button"
    >
      <span>Туристам</span>
      <b-icon icon="menu-down" />
    </button>
    <b-dropdown-item
      :has-link="true"
      :disabled="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Финансовые гарантии
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :has-link="true"
      :disabled="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Поддержка
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :has-link="true"
      :disabled="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Способы оплаты
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :has-link="true"
      :disabled="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Частые вопросы
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :has-link="true"
      :disabled="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Контакты
      </router-link>
    </b-dropdown-item>
  </b-dropdown>
</template>
